"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionApi = exports.RequisitionApiFactory = exports.RequisitionApiFp = exports.RequisitionApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * RequisitionApi - axios parameter creator
 * @export
 */
var RequisitionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary marks the RQ as complete and returns the updated rq review status
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRqReviewFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('completeRqReviewFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/complete-rq-review"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create blank requisition.
         * @param {AccessionedRequisitionRequestDto} accessionedRequisitionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlankRequisitionFromRequisitionController: function (accessionedRequisitionRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accessionedRequisitionRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createBlankRequisitionFromRequisitionController', 'accessionedRequisitionRequestDto', accessionedRequisitionRequestDto);
                            localVarPath = "/requisition/blank";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessionedRequisitionRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new message, optionally a new conversation or participant
         * @param {number} reqid
         * @param {NewConversationRequestDto} newConversationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversationFromRequisitionController: function (reqid, newConversationRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('createConversationFromRequisitionController', 'reqid', reqid);
                            // verify required parameter 'newConversationRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createConversationFromRequisitionController', 'newConversationRequestDto', newConversationRequestDto);
                            localVarPath = "/requisition/{reqid}/conversations"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(newConversationRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new note for a requisition
         * @param {number} reqid
         * @param {NewNotePayload} newNotePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNoteFromRequisitionController: function (reqid, newNotePayload, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('createNoteFromRequisitionController', 'reqid', reqid);
                            // verify required parameter 'newNotePayload' is not null or undefined
                            (0, common_1.assertParamExists)('createNoteFromRequisitionController', 'newNotePayload', newNotePayload);
                            localVarPath = "/requisition/{reqid}/notes"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(newNotePayload, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of active carrier couple consents for this requisition
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCarrierCouplesConsentsFromRequisitionController: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getActiveCarrierCouplesConsentsFromRequisitionController', 'id', id);
                            localVarPath = "/requisition/{id}/carrier-couples-consents/active-consents"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Download an attachment by requisition and attachment id
         * @param {string} id
         * @param {string} attachmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentFromRequisitionController: function (id, attachmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getAttachmentFromRequisitionController', 'id', id);
                            // verify required parameter 'attachmentId' is not null or undefined
                            (0, common_1.assertParamExists)('getAttachmentFromRequisitionController', 'attachmentId', attachmentId);
                            localVarPath = "/requisition/{id}/attachments/{attachmentId}/download"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("attachmentId", "}"), encodeURIComponent(String(attachmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of all carrier couple consents for this requisition
         * @param {number} id
         * @param {boolean} includePartnerConsents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierCouplesConsentsFromRequisitionController: function (id, includePartnerConsents, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getCarrierCouplesConsentsFromRequisitionController', 'id', id);
                            // verify required parameter 'includePartnerConsents' is not null or undefined
                            (0, common_1.assertParamExists)('getCarrierCouplesConsentsFromRequisitionController', 'includePartnerConsents', includePartnerConsents);
                            localVarPath = "/requisition/{id}/carrier-couples-consents"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (includePartnerConsents !== undefined) {
                                localVarQueryParameter['includePartnerConsents'] = includePartnerConsents;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the clinical team for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTeamFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('getClinicalTeamFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/clinical-team"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the paginated list of messages for a Requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationsFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('getConversationsFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/conversations"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the notes for a requisition
         * @param {number} reqid
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesFromRequisitionController: function (reqid, page, perPage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('getNotesFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/notes"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (perPage !== undefined) {
                                localVarQueryParameter['perPage'] = perPage;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the reasons for testing data for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReasonsForTestingFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('getReasonsForTestingFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/reasons-for-testing"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns reported variants for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportedVariantOptionsFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('getReportedVariantOptionsFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/reported-variants"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('getRequisitionFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of requisition reviews
         * @param {string} [q]
         * @param {string} [eid]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {'ORDER_SUBMITTED' | 'SPECIMEN_RECEIVED' | 'LAB_PROCESSING' | 'PRE_CROP_HOLD' | 'ANALYSIS_AND_INTERPRETATION' | 'POST_CROP_HOLD' | 'REPORT_RELEASED' | 'ON_HOLD' | 'ORDER_PROCESSING' | 'RQ_REVIEW'} [orderStage]
         * @param {string} [ordering]
         * @param {Array<'carrier' | 'combi_cc' | 'combi_cdd' | 'combi_pd' | 'combi_pfu' | 'combi_poc' | 'combi_rpl' | 'diagnostic' | 'exome' | 'exome_preventive_addon' | 'nips' | 'pgx' | 'preventive' | 'sma-stat' | 'solid_tumor' | 'stat' | 'tumor_profiling' | 'wgs'>} [orderType]
         * @param {Array<string>} [studyCode]
         * @param {Array<'clinical_follow_up' | 'is_verification_only' | 'no_status'>} [status]
         * @param {Array<string>} [countries]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionListFromRequisitionController: function (q, eid, page, perPage, orderStage, ordering, orderType, studyCode, status, countries, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/requisition/requisition-list";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (eid !== undefined) {
                                localVarQueryParameter['eid'] = eid;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (perPage !== undefined) {
                                localVarQueryParameter['perPage'] = perPage;
                            }
                            if (orderStage !== undefined) {
                                localVarQueryParameter['orderStage'] = orderStage;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (orderType) {
                                localVarQueryParameter['orderType'] = orderType;
                            }
                            if (studyCode) {
                                localVarQueryParameter['studyCode'] = studyCode;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (countries) {
                                localVarQueryParameter['countries'] = countries;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns paginated list of requisitions with the ability to filter by requisition ids or specimen ids
         * @param {string} [paginator]
         * @param {string} [dateModifiedGte]
         * @param {string} [dateModifiedGt]
         * @param {string} [dateModifiedLte]
         * @param {string} [dateModifiedLt]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {Array<string>} [reqids]
         * @param {Array<string>} [specimenSids]
         * @param {Array<string>} [fields]
         * @param {Array<string>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionsFromRequisitionController: function (paginator, dateModifiedGte, dateModifiedGt, dateModifiedLte, dateModifiedLt, page, perPage, reqids, specimenSids, fields, include, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/requisition/requisitions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (paginator !== undefined) {
                                localVarQueryParameter['paginator'] = paginator;
                            }
                            if (dateModifiedGte !== undefined) {
                                localVarQueryParameter['dateModifiedGte'] = dateModifiedGte;
                            }
                            if (dateModifiedGt !== undefined) {
                                localVarQueryParameter['dateModifiedGt'] = dateModifiedGt;
                            }
                            if (dateModifiedLte !== undefined) {
                                localVarQueryParameter['dateModifiedLte'] = dateModifiedLte;
                            }
                            if (dateModifiedLt !== undefined) {
                                localVarQueryParameter['dateModifiedLt'] = dateModifiedLt;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (perPage !== undefined) {
                                localVarQueryParameter['perPage'] = perPage;
                            }
                            if (reqids) {
                                localVarQueryParameter['reqids'] = reqids;
                            }
                            if (specimenSids) {
                                localVarQueryParameter['specimenSids'] = specimenSids;
                            }
                            if (fields) {
                                localVarQueryParameter['fields'] = fields;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns specimens information
         * @param {string} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecimensFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('getSpecimensFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/specimens"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the list of activity for the given requisition
         * @param {number} reqid
         * @param {boolean} [hideClinicalInformation]
         * @param {boolean} [includeSmsStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivityFromRequisitionController: function (reqid, hideClinicalInformation, includeSmsStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('listActivityFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/activity"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (hideClinicalInformation !== undefined) {
                                localVarQueryParameter['hideClinicalInformation'] = hideClinicalInformation;
                            }
                            if (includeSmsStatus !== undefined) {
                                localVarQueryParameter['includeSmsStatus'] = includeSmsStatus;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List attachments attached to a requisition
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachmentsFromRequisitionController: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('listAttachmentsFromRequisitionController', 'id', id);
                            localVarPath = "/requisition/{id}/attachments"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates requisition \'clinical_follow_up\' tag
         * @param {number} reqid
         * @param {ClinicalFollowUpRequestBody} clinicalFollowUpRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchClinicalFollowUpFromRequisitionController: function (reqid, clinicalFollowUpRequestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('patchClinicalFollowUpFromRequisitionController', 'reqid', reqid);
                            // verify required parameter 'clinicalFollowUpRequestBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchClinicalFollowUpFromRequisitionController', 'clinicalFollowUpRequestBody', clinicalFollowUpRequestBody);
                            localVarPath = "/requisition/{reqid}/clinical-follow-up"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(clinicalFollowUpRequestBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Patches a note for a requisition
         * @param {number} reqid
         * @param {number} noteId
         * @param {PatchNotePayloadDto} patchNotePayloadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchNoteFromRequisitionController: function (reqid, noteId, patchNotePayloadDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('patchNoteFromRequisitionController', 'reqid', reqid);
                            // verify required parameter 'noteId' is not null or undefined
                            (0, common_1.assertParamExists)('patchNoteFromRequisitionController', 'noteId', noteId);
                            // verify required parameter 'patchNotePayloadDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchNoteFromRequisitionController', 'patchNotePayloadDto', patchNotePayloadDto);
                            localVarPath = "/requisition/{reqid}/notes/{noteId}"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)))
                                .replace("{".concat("noteId", "}"), encodeURIComponent(String(noteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchNotePayloadDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a requisition clinical team, practice/owner/ordering_clinician/delegates
         * @param {number} reqid
         * @param {PatchRequisitionClinicalTeamDto} patchRequisitionClinicalTeamDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRequisitionClinicalTeamFromRequisitionController: function (reqid, patchRequisitionClinicalTeamDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('patchRequisitionClinicalTeamFromRequisitionController', 'reqid', reqid);
                            // verify required parameter 'patchRequisitionClinicalTeamDto' is not null or undefined
                            (0, common_1.assertParamExists)('patchRequisitionClinicalTeamFromRequisitionController', 'patchRequisitionClinicalTeamDto', patchRequisitionClinicalTeamDto);
                            localVarPath = "/requisition/{reqid}"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchRequisitionClinicalTeamDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a Medical Necessity Letter and optionally upload the PDF for a requisition
         * @param {number} id
         * @param {string} [allowUnconfirmedFields] whether to allow unconfirmed fields (indications, attributes, relatives) to be used when planning
         * @param {string} [upload] whether to upload pdf to reqrepo
         * @param {string} [adminMode] whether to use admin (debug) mode for LMN generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMedicalNecessityLetterFromRequisitionController: function (id, allowUnconfirmedFields, upload, adminMode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('postMedicalNecessityLetterFromRequisitionController', 'id', id);
                            localVarPath = "/requisition/{id}/medical-necessity-letter"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (allowUnconfirmedFields !== undefined) {
                                localVarQueryParameter['allowUnconfirmedFields'] = allowUnconfirmedFields;
                            }
                            if (upload !== undefined) {
                                localVarQueryParameter['upload'] = upload;
                            }
                            if (adminMode !== undefined) {
                                localVarQueryParameter['adminMode'] = adminMode;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates the last_viewed at field and returns the updated rq review status
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rqReviewStatusFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('rqReviewStatusFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/rq-review-status"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of requisition identifiers based on reqid search qp
         * @param {string} search
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {string} [ordering]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRequisitionIdsFromRequisitionController: function (search, page, perPage, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'search' is not null or undefined
                            (0, common_1.assertParamExists)('searchRequisitionIdsFromRequisitionController', 'search', search);
                            localVarPath = "/requisition/search-reqids";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (perPage !== undefined) {
                                localVarQueryParameter['perPage'] = perPage;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Search by: patient name, email, dob, mrn; requisition_ids or specimen_ids. At least one search criteria is required.
         * @summary Search for requisitions
         * @param {RequisitionSearchRequestDto} requisitionSearchRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRequisitionsFromRequisitionController: function (requisitionSearchRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'requisitionSearchRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('searchRequisitionsFromRequisitionController', 'requisitionSearchRequestDto', requisitionSearchRequestDto);
                            localVarPath = "/requisition/search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requisitionSearchRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns FVT suggestions given the current state of FVT details for an RQ
         * @param {SuggestionsFVTDetailsDto} suggestionsFVTDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionsForFvtFromRequisitionController: function (suggestionsFVTDetailsDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'suggestionsFVTDetailsDto' is not null or undefined
                            (0, common_1.assertParamExists)('suggestionsForFvtFromRequisitionController', 'suggestionsFVTDetailsDto', suggestionsFVTDetailsDto);
                            localVarPath = "/requisition/suggestions-for-fvt";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(suggestionsFVTDetailsDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates requisition price
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePricingFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('updatePricingFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/update-pricing"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add an attachment to the given requisition.
         * @param {number} id Primary id of the requisition.
         * @param {RequisitionAttachmentRequestDto} requisitionAttachmentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachmentsFromRequisitionController: function (id, requisitionAttachmentRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('uploadAttachmentsFromRequisitionController', 'id', id);
                            // verify required parameter 'requisitionAttachmentRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('uploadAttachmentsFromRequisitionController', 'requisitionAttachmentRequestDto', requisitionAttachmentRequestDto);
                            localVarPath = "/requisition/{id}/attachments"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requisitionAttachmentRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns reported variants for a requisition
         * @param {VariantsAndCommercialTestsRequestDto} variantsAndCommercialTestsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVariantsAndGenesFromRequisitionController: function (variantsAndCommercialTestsRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'variantsAndCommercialTestsRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('validateVariantsAndGenesFromRequisitionController', 'variantsAndCommercialTestsRequestDto', variantsAndCommercialTestsRequestDto);
                            localVarPath = "/requisition/validate-variants-and-genes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(variantsAndCommercialTestsRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Verify specimen
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySpecimenFromRequisitionController: function (reqid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'reqid' is not null or undefined
                            (0, common_1.assertParamExists)('verifySpecimenFromRequisitionController', 'reqid', reqid);
                            localVarPath = "/requisition/{reqid}/verify-specimen"
                                .replace("{".concat("reqid", "}"), encodeURIComponent(String(reqid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        youScriptResultsFromRequisitionController: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('youScriptResultsFromRequisitionController', 'id', id);
                            localVarPath = "/requisition/{id}/youscript-results"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)
                                // authentication cookie required
                            ];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            // authentication cookie required
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RequisitionApiAxiosParamCreator = RequisitionApiAxiosParamCreator;
/**
 * RequisitionApi - functional programming interface
 * @export
 */
var RequisitionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RequisitionApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary marks the RQ as complete and returns the updated rq review status
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRqReviewFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.completeRqReviewFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create blank requisition.
         * @param {AccessionedRequisitionRequestDto} accessionedRequisitionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlankRequisitionFromRequisitionController: function (accessionedRequisitionRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBlankRequisitionFromRequisitionController(accessionedRequisitionRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new message, optionally a new conversation or participant
         * @param {number} reqid
         * @param {NewConversationRequestDto} newConversationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversationFromRequisitionController: function (reqid, newConversationRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createConversationFromRequisitionController(reqid, newConversationRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new note for a requisition
         * @param {number} reqid
         * @param {NewNotePayload} newNotePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNoteFromRequisitionController: function (reqid, newNotePayload, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createNoteFromRequisitionController(reqid, newNotePayload, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of active carrier couple consents for this requisition
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCarrierCouplesConsentsFromRequisitionController: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getActiveCarrierCouplesConsentsFromRequisitionController(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Download an attachment by requisition and attachment id
         * @param {string} id
         * @param {string} attachmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentFromRequisitionController: function (id, attachmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAttachmentFromRequisitionController(id, attachmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of all carrier couple consents for this requisition
         * @param {number} id
         * @param {boolean} includePartnerConsents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierCouplesConsentsFromRequisitionController: function (id, includePartnerConsents, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCarrierCouplesConsentsFromRequisitionController(id, includePartnerConsents, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the clinical team for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTeamFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getClinicalTeamFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the paginated list of messages for a Requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationsFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getConversationsFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the notes for a requisition
         * @param {number} reqid
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesFromRequisitionController: function (reqid, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNotesFromRequisitionController(reqid, page, perPage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the reasons for testing data for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReasonsForTestingFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReasonsForTestingFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns reported variants for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportedVariantOptionsFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReportedVariantOptionsFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRequisitionFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of requisition reviews
         * @param {string} [q]
         * @param {string} [eid]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {'ORDER_SUBMITTED' | 'SPECIMEN_RECEIVED' | 'LAB_PROCESSING' | 'PRE_CROP_HOLD' | 'ANALYSIS_AND_INTERPRETATION' | 'POST_CROP_HOLD' | 'REPORT_RELEASED' | 'ON_HOLD' | 'ORDER_PROCESSING' | 'RQ_REVIEW'} [orderStage]
         * @param {string} [ordering]
         * @param {Array<'carrier' | 'combi_cc' | 'combi_cdd' | 'combi_pd' | 'combi_pfu' | 'combi_poc' | 'combi_rpl' | 'diagnostic' | 'exome' | 'exome_preventive_addon' | 'nips' | 'pgx' | 'preventive' | 'sma-stat' | 'solid_tumor' | 'stat' | 'tumor_profiling' | 'wgs'>} [orderType]
         * @param {Array<string>} [studyCode]
         * @param {Array<'clinical_follow_up' | 'is_verification_only' | 'no_status'>} [status]
         * @param {Array<string>} [countries]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionListFromRequisitionController: function (q, eid, page, perPage, orderStage, ordering, orderType, studyCode, status, countries, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRequisitionListFromRequisitionController(q, eid, page, perPage, orderStage, ordering, orderType, studyCode, status, countries, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns paginated list of requisitions with the ability to filter by requisition ids or specimen ids
         * @param {string} [paginator]
         * @param {string} [dateModifiedGte]
         * @param {string} [dateModifiedGt]
         * @param {string} [dateModifiedLte]
         * @param {string} [dateModifiedLt]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {Array<string>} [reqids]
         * @param {Array<string>} [specimenSids]
         * @param {Array<string>} [fields]
         * @param {Array<string>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionsFromRequisitionController: function (paginator, dateModifiedGte, dateModifiedGt, dateModifiedLte, dateModifiedLt, page, perPage, reqids, specimenSids, fields, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRequisitionsFromRequisitionController(paginator, dateModifiedGte, dateModifiedGt, dateModifiedLte, dateModifiedLt, page, perPage, reqids, specimenSids, fields, include, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns specimens information
         * @param {string} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecimensFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSpecimensFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the list of activity for the given requisition
         * @param {number} reqid
         * @param {boolean} [hideClinicalInformation]
         * @param {boolean} [includeSmsStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivityFromRequisitionController: function (reqid, hideClinicalInformation, includeSmsStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listActivityFromRequisitionController(reqid, hideClinicalInformation, includeSmsStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List attachments attached to a requisition
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachmentsFromRequisitionController: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listAttachmentsFromRequisitionController(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates requisition \'clinical_follow_up\' tag
         * @param {number} reqid
         * @param {ClinicalFollowUpRequestBody} clinicalFollowUpRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchClinicalFollowUpFromRequisitionController: function (reqid, clinicalFollowUpRequestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchClinicalFollowUpFromRequisitionController(reqid, clinicalFollowUpRequestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Patches a note for a requisition
         * @param {number} reqid
         * @param {number} noteId
         * @param {PatchNotePayloadDto} patchNotePayloadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchNoteFromRequisitionController: function (reqid, noteId, patchNotePayloadDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchNoteFromRequisitionController(reqid, noteId, patchNotePayloadDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a requisition clinical team, practice/owner/ordering_clinician/delegates
         * @param {number} reqid
         * @param {PatchRequisitionClinicalTeamDto} patchRequisitionClinicalTeamDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRequisitionClinicalTeamFromRequisitionController: function (reqid, patchRequisitionClinicalTeamDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchRequisitionClinicalTeamFromRequisitionController(reqid, patchRequisitionClinicalTeamDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a Medical Necessity Letter and optionally upload the PDF for a requisition
         * @param {number} id
         * @param {string} [allowUnconfirmedFields] whether to allow unconfirmed fields (indications, attributes, relatives) to be used when planning
         * @param {string} [upload] whether to upload pdf to reqrepo
         * @param {string} [adminMode] whether to use admin (debug) mode for LMN generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMedicalNecessityLetterFromRequisitionController: function (id, allowUnconfirmedFields, upload, adminMode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postMedicalNecessityLetterFromRequisitionController(id, allowUnconfirmedFields, upload, adminMode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates the last_viewed at field and returns the updated rq review status
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rqReviewStatusFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rqReviewStatusFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of requisition identifiers based on reqid search qp
         * @param {string} search
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {string} [ordering]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRequisitionIdsFromRequisitionController: function (search, page, perPage, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchRequisitionIdsFromRequisitionController(search, page, perPage, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Search by: patient name, email, dob, mrn; requisition_ids or specimen_ids. At least one search criteria is required.
         * @summary Search for requisitions
         * @param {RequisitionSearchRequestDto} requisitionSearchRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRequisitionsFromRequisitionController: function (requisitionSearchRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchRequisitionsFromRequisitionController(requisitionSearchRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns FVT suggestions given the current state of FVT details for an RQ
         * @param {SuggestionsFVTDetailsDto} suggestionsFVTDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionsForFvtFromRequisitionController: function (suggestionsFVTDetailsDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suggestionsForFvtFromRequisitionController(suggestionsFVTDetailsDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates requisition price
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePricingFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePricingFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add an attachment to the given requisition.
         * @param {number} id Primary id of the requisition.
         * @param {RequisitionAttachmentRequestDto} requisitionAttachmentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachmentsFromRequisitionController: function (id, requisitionAttachmentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadAttachmentsFromRequisitionController(id, requisitionAttachmentRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns reported variants for a requisition
         * @param {VariantsAndCommercialTestsRequestDto} variantsAndCommercialTestsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVariantsAndGenesFromRequisitionController: function (variantsAndCommercialTestsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.validateVariantsAndGenesFromRequisitionController(variantsAndCommercialTestsRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Verify specimen
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySpecimenFromRequisitionController: function (reqid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.verifySpecimenFromRequisitionController(reqid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        youScriptResultsFromRequisitionController: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.youScriptResultsFromRequisitionController(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RequisitionApiFp = RequisitionApiFp;
/**
 * RequisitionApi - factory interface
 * @export
 */
var RequisitionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RequisitionApiFp)(configuration);
    return {
        /**
         *
         * @summary marks the RQ as complete and returns the updated rq review status
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeRqReviewFromRequisitionController: function (reqid, options) {
            return localVarFp.completeRqReviewFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create blank requisition.
         * @param {AccessionedRequisitionRequestDto} accessionedRequisitionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlankRequisitionFromRequisitionController: function (accessionedRequisitionRequestDto, options) {
            return localVarFp.createBlankRequisitionFromRequisitionController(accessionedRequisitionRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new message, optionally a new conversation or participant
         * @param {number} reqid
         * @param {NewConversationRequestDto} newConversationRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversationFromRequisitionController: function (reqid, newConversationRequestDto, options) {
            return localVarFp.createConversationFromRequisitionController(reqid, newConversationRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new note for a requisition
         * @param {number} reqid
         * @param {NewNotePayload} newNotePayload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNoteFromRequisitionController: function (reqid, newNotePayload, options) {
            return localVarFp.createNoteFromRequisitionController(reqid, newNotePayload, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of active carrier couple consents for this requisition
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCarrierCouplesConsentsFromRequisitionController: function (id, options) {
            return localVarFp.getActiveCarrierCouplesConsentsFromRequisitionController(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Download an attachment by requisition and attachment id
         * @param {string} id
         * @param {string} attachmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentFromRequisitionController: function (id, attachmentId, options) {
            return localVarFp.getAttachmentFromRequisitionController(id, attachmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of all carrier couple consents for this requisition
         * @param {number} id
         * @param {boolean} includePartnerConsents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierCouplesConsentsFromRequisitionController: function (id, includePartnerConsents, options) {
            return localVarFp.getCarrierCouplesConsentsFromRequisitionController(id, includePartnerConsents, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the clinical team for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalTeamFromRequisitionController: function (reqid, options) {
            return localVarFp.getClinicalTeamFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the paginated list of messages for a Requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationsFromRequisitionController: function (reqid, options) {
            return localVarFp.getConversationsFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the notes for a requisition
         * @param {number} reqid
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotesFromRequisitionController: function (reqid, page, perPage, options) {
            return localVarFp.getNotesFromRequisitionController(reqid, page, perPage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the reasons for testing data for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReasonsForTestingFromRequisitionController: function (reqid, options) {
            return localVarFp.getReasonsForTestingFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns reported variants for a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportedVariantOptionsFromRequisitionController: function (reqid, options) {
            return localVarFp.getReportedVariantOptionsFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a requisition
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionFromRequisitionController: function (reqid, options) {
            return localVarFp.getRequisitionFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of requisition reviews
         * @param {string} [q]
         * @param {string} [eid]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {'ORDER_SUBMITTED' | 'SPECIMEN_RECEIVED' | 'LAB_PROCESSING' | 'PRE_CROP_HOLD' | 'ANALYSIS_AND_INTERPRETATION' | 'POST_CROP_HOLD' | 'REPORT_RELEASED' | 'ON_HOLD' | 'ORDER_PROCESSING' | 'RQ_REVIEW'} [orderStage]
         * @param {string} [ordering]
         * @param {Array<'carrier' | 'combi_cc' | 'combi_cdd' | 'combi_pd' | 'combi_pfu' | 'combi_poc' | 'combi_rpl' | 'diagnostic' | 'exome' | 'exome_preventive_addon' | 'nips' | 'pgx' | 'preventive' | 'sma-stat' | 'solid_tumor' | 'stat' | 'tumor_profiling' | 'wgs'>} [orderType]
         * @param {Array<string>} [studyCode]
         * @param {Array<'clinical_follow_up' | 'is_verification_only' | 'no_status'>} [status]
         * @param {Array<string>} [countries]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionListFromRequisitionController: function (q, eid, page, perPage, orderStage, ordering, orderType, studyCode, status, countries, options) {
            return localVarFp.getRequisitionListFromRequisitionController(q, eid, page, perPage, orderStage, ordering, orderType, studyCode, status, countries, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns paginated list of requisitions with the ability to filter by requisition ids or specimen ids
         * @param {string} [paginator]
         * @param {string} [dateModifiedGte]
         * @param {string} [dateModifiedGt]
         * @param {string} [dateModifiedLte]
         * @param {string} [dateModifiedLt]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {Array<string>} [reqids]
         * @param {Array<string>} [specimenSids]
         * @param {Array<string>} [fields]
         * @param {Array<string>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequisitionsFromRequisitionController: function (paginator, dateModifiedGte, dateModifiedGt, dateModifiedLte, dateModifiedLt, page, perPage, reqids, specimenSids, fields, include, options) {
            return localVarFp.getRequisitionsFromRequisitionController(paginator, dateModifiedGte, dateModifiedGt, dateModifiedLte, dateModifiedLt, page, perPage, reqids, specimenSids, fields, include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns specimens information
         * @param {string} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecimensFromRequisitionController: function (reqid, options) {
            return localVarFp.getSpecimensFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the list of activity for the given requisition
         * @param {number} reqid
         * @param {boolean} [hideClinicalInformation]
         * @param {boolean} [includeSmsStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivityFromRequisitionController: function (reqid, hideClinicalInformation, includeSmsStatus, options) {
            return localVarFp.listActivityFromRequisitionController(reqid, hideClinicalInformation, includeSmsStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List attachments attached to a requisition
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachmentsFromRequisitionController: function (id, options) {
            return localVarFp.listAttachmentsFromRequisitionController(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates requisition \'clinical_follow_up\' tag
         * @param {number} reqid
         * @param {ClinicalFollowUpRequestBody} clinicalFollowUpRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchClinicalFollowUpFromRequisitionController: function (reqid, clinicalFollowUpRequestBody, options) {
            return localVarFp.patchClinicalFollowUpFromRequisitionController(reqid, clinicalFollowUpRequestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Patches a note for a requisition
         * @param {number} reqid
         * @param {number} noteId
         * @param {PatchNotePayloadDto} patchNotePayloadDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchNoteFromRequisitionController: function (reqid, noteId, patchNotePayloadDto, options) {
            return localVarFp.patchNoteFromRequisitionController(reqid, noteId, patchNotePayloadDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a requisition clinical team, practice/owner/ordering_clinician/delegates
         * @param {number} reqid
         * @param {PatchRequisitionClinicalTeamDto} patchRequisitionClinicalTeamDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRequisitionClinicalTeamFromRequisitionController: function (reqid, patchRequisitionClinicalTeamDto, options) {
            return localVarFp.patchRequisitionClinicalTeamFromRequisitionController(reqid, patchRequisitionClinicalTeamDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a Medical Necessity Letter and optionally upload the PDF for a requisition
         * @param {number} id
         * @param {string} [allowUnconfirmedFields] whether to allow unconfirmed fields (indications, attributes, relatives) to be used when planning
         * @param {string} [upload] whether to upload pdf to reqrepo
         * @param {string} [adminMode] whether to use admin (debug) mode for LMN generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMedicalNecessityLetterFromRequisitionController: function (id, allowUnconfirmedFields, upload, adminMode, options) {
            return localVarFp.postMedicalNecessityLetterFromRequisitionController(id, allowUnconfirmedFields, upload, adminMode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates the last_viewed at field and returns the updated rq review status
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rqReviewStatusFromRequisitionController: function (reqid, options) {
            return localVarFp.rqReviewStatusFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of requisition identifiers based on reqid search qp
         * @param {string} search
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {string} [ordering]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRequisitionIdsFromRequisitionController: function (search, page, perPage, ordering, options) {
            return localVarFp.searchRequisitionIdsFromRequisitionController(search, page, perPage, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Search by: patient name, email, dob, mrn; requisition_ids or specimen_ids. At least one search criteria is required.
         * @summary Search for requisitions
         * @param {RequisitionSearchRequestDto} requisitionSearchRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRequisitionsFromRequisitionController: function (requisitionSearchRequestDto, options) {
            return localVarFp.searchRequisitionsFromRequisitionController(requisitionSearchRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns FVT suggestions given the current state of FVT details for an RQ
         * @param {SuggestionsFVTDetailsDto} suggestionsFVTDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionsForFvtFromRequisitionController: function (suggestionsFVTDetailsDto, options) {
            return localVarFp.suggestionsForFvtFromRequisitionController(suggestionsFVTDetailsDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates requisition price
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePricingFromRequisitionController: function (reqid, options) {
            return localVarFp.updatePricingFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add an attachment to the given requisition.
         * @param {number} id Primary id of the requisition.
         * @param {RequisitionAttachmentRequestDto} requisitionAttachmentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachmentsFromRequisitionController: function (id, requisitionAttachmentRequestDto, options) {
            return localVarFp.uploadAttachmentsFromRequisitionController(id, requisitionAttachmentRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns reported variants for a requisition
         * @param {VariantsAndCommercialTestsRequestDto} variantsAndCommercialTestsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVariantsAndGenesFromRequisitionController: function (variantsAndCommercialTestsRequestDto, options) {
            return localVarFp.validateVariantsAndGenesFromRequisitionController(variantsAndCommercialTestsRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Verify specimen
         * @param {number} reqid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySpecimenFromRequisitionController: function (reqid, options) {
            return localVarFp.verifySpecimenFromRequisitionController(reqid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        youScriptResultsFromRequisitionController: function (id, options) {
            return localVarFp.youScriptResultsFromRequisitionController(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RequisitionApiFactory = RequisitionApiFactory;
/**
 * RequisitionApi - object-oriented interface
 * @export
 * @class RequisitionApi
 * @extends {BaseAPI}
 */
var RequisitionApi = /** @class */ (function (_super) {
    __extends(RequisitionApi, _super);
    function RequisitionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary marks the RQ as complete and returns the updated rq review status
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.completeRqReviewFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).completeRqReviewFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create blank requisition.
     * @param {AccessionedRequisitionRequestDto} accessionedRequisitionRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.createBlankRequisitionFromRequisitionController = function (accessionedRequisitionRequestDto, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).createBlankRequisitionFromRequisitionController(accessionedRequisitionRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new message, optionally a new conversation or participant
     * @param {number} reqid
     * @param {NewConversationRequestDto} newConversationRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.createConversationFromRequisitionController = function (reqid, newConversationRequestDto, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).createConversationFromRequisitionController(reqid, newConversationRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new note for a requisition
     * @param {number} reqid
     * @param {NewNotePayload} newNotePayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.createNoteFromRequisitionController = function (reqid, newNotePayload, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).createNoteFromRequisitionController(reqid, newNotePayload, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of active carrier couple consents for this requisition
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getActiveCarrierCouplesConsentsFromRequisitionController = function (id, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getActiveCarrierCouplesConsentsFromRequisitionController(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Download an attachment by requisition and attachment id
     * @param {string} id
     * @param {string} attachmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getAttachmentFromRequisitionController = function (id, attachmentId, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getAttachmentFromRequisitionController(id, attachmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of all carrier couple consents for this requisition
     * @param {number} id
     * @param {boolean} includePartnerConsents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getCarrierCouplesConsentsFromRequisitionController = function (id, includePartnerConsents, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getCarrierCouplesConsentsFromRequisitionController(id, includePartnerConsents, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the clinical team for a requisition
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getClinicalTeamFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getClinicalTeamFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the paginated list of messages for a Requisition
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getConversationsFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getConversationsFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the notes for a requisition
     * @param {number} reqid
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getNotesFromRequisitionController = function (reqid, page, perPage, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getNotesFromRequisitionController(reqid, page, perPage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the reasons for testing data for a requisition
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getReasonsForTestingFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getReasonsForTestingFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns reported variants for a requisition
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getReportedVariantOptionsFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getReportedVariantOptionsFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a requisition
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getRequisitionFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getRequisitionFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of requisition reviews
     * @param {string} [q]
     * @param {string} [eid]
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {'ORDER_SUBMITTED' | 'SPECIMEN_RECEIVED' | 'LAB_PROCESSING' | 'PRE_CROP_HOLD' | 'ANALYSIS_AND_INTERPRETATION' | 'POST_CROP_HOLD' | 'REPORT_RELEASED' | 'ON_HOLD' | 'ORDER_PROCESSING' | 'RQ_REVIEW'} [orderStage]
     * @param {string} [ordering]
     * @param {Array<'carrier' | 'combi_cc' | 'combi_cdd' | 'combi_pd' | 'combi_pfu' | 'combi_poc' | 'combi_rpl' | 'diagnostic' | 'exome' | 'exome_preventive_addon' | 'nips' | 'pgx' | 'preventive' | 'sma-stat' | 'solid_tumor' | 'stat' | 'tumor_profiling' | 'wgs'>} [orderType]
     * @param {Array<string>} [studyCode]
     * @param {Array<'clinical_follow_up' | 'is_verification_only' | 'no_status'>} [status]
     * @param {Array<string>} [countries]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getRequisitionListFromRequisitionController = function (q, eid, page, perPage, orderStage, ordering, orderType, studyCode, status, countries, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getRequisitionListFromRequisitionController(q, eid, page, perPage, orderStage, ordering, orderType, studyCode, status, countries, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns paginated list of requisitions with the ability to filter by requisition ids or specimen ids
     * @param {string} [paginator]
     * @param {string} [dateModifiedGte]
     * @param {string} [dateModifiedGt]
     * @param {string} [dateModifiedLte]
     * @param {string} [dateModifiedLt]
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {Array<string>} [reqids]
     * @param {Array<string>} [specimenSids]
     * @param {Array<string>} [fields]
     * @param {Array<string>} [include]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getRequisitionsFromRequisitionController = function (paginator, dateModifiedGte, dateModifiedGt, dateModifiedLte, dateModifiedLt, page, perPage, reqids, specimenSids, fields, include, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getRequisitionsFromRequisitionController(paginator, dateModifiedGte, dateModifiedGt, dateModifiedLte, dateModifiedLt, page, perPage, reqids, specimenSids, fields, include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns specimens information
     * @param {string} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.getSpecimensFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).getSpecimensFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the list of activity for the given requisition
     * @param {number} reqid
     * @param {boolean} [hideClinicalInformation]
     * @param {boolean} [includeSmsStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.listActivityFromRequisitionController = function (reqid, hideClinicalInformation, includeSmsStatus, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).listActivityFromRequisitionController(reqid, hideClinicalInformation, includeSmsStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List attachments attached to a requisition
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.listAttachmentsFromRequisitionController = function (id, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).listAttachmentsFromRequisitionController(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates requisition \'clinical_follow_up\' tag
     * @param {number} reqid
     * @param {ClinicalFollowUpRequestBody} clinicalFollowUpRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.patchClinicalFollowUpFromRequisitionController = function (reqid, clinicalFollowUpRequestBody, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).patchClinicalFollowUpFromRequisitionController(reqid, clinicalFollowUpRequestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Patches a note for a requisition
     * @param {number} reqid
     * @param {number} noteId
     * @param {PatchNotePayloadDto} patchNotePayloadDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.patchNoteFromRequisitionController = function (reqid, noteId, patchNotePayloadDto, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).patchNoteFromRequisitionController(reqid, noteId, patchNotePayloadDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a requisition clinical team, practice/owner/ordering_clinician/delegates
     * @param {number} reqid
     * @param {PatchRequisitionClinicalTeamDto} patchRequisitionClinicalTeamDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.patchRequisitionClinicalTeamFromRequisitionController = function (reqid, patchRequisitionClinicalTeamDto, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).patchRequisitionClinicalTeamFromRequisitionController(reqid, patchRequisitionClinicalTeamDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a Medical Necessity Letter and optionally upload the PDF for a requisition
     * @param {number} id
     * @param {string} [allowUnconfirmedFields] whether to allow unconfirmed fields (indications, attributes, relatives) to be used when planning
     * @param {string} [upload] whether to upload pdf to reqrepo
     * @param {string} [adminMode] whether to use admin (debug) mode for LMN generation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.postMedicalNecessityLetterFromRequisitionController = function (id, allowUnconfirmedFields, upload, adminMode, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).postMedicalNecessityLetterFromRequisitionController(id, allowUnconfirmedFields, upload, adminMode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates the last_viewed at field and returns the updated rq review status
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.rqReviewStatusFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).rqReviewStatusFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of requisition identifiers based on reqid search qp
     * @param {string} search
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {string} [ordering]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.searchRequisitionIdsFromRequisitionController = function (search, page, perPage, ordering, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).searchRequisitionIdsFromRequisitionController(search, page, perPage, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Search by: patient name, email, dob, mrn; requisition_ids or specimen_ids. At least one search criteria is required.
     * @summary Search for requisitions
     * @param {RequisitionSearchRequestDto} requisitionSearchRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.searchRequisitionsFromRequisitionController = function (requisitionSearchRequestDto, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).searchRequisitionsFromRequisitionController(requisitionSearchRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns FVT suggestions given the current state of FVT details for an RQ
     * @param {SuggestionsFVTDetailsDto} suggestionsFVTDetailsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.suggestionsForFvtFromRequisitionController = function (suggestionsFVTDetailsDto, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).suggestionsForFvtFromRequisitionController(suggestionsFVTDetailsDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates requisition price
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.updatePricingFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).updatePricingFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add an attachment to the given requisition.
     * @param {number} id Primary id of the requisition.
     * @param {RequisitionAttachmentRequestDto} requisitionAttachmentRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.uploadAttachmentsFromRequisitionController = function (id, requisitionAttachmentRequestDto, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).uploadAttachmentsFromRequisitionController(id, requisitionAttachmentRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns reported variants for a requisition
     * @param {VariantsAndCommercialTestsRequestDto} variantsAndCommercialTestsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.validateVariantsAndGenesFromRequisitionController = function (variantsAndCommercialTestsRequestDto, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).validateVariantsAndGenesFromRequisitionController(variantsAndCommercialTestsRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Verify specimen
     * @param {number} reqid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.verifySpecimenFromRequisitionController = function (reqid, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).verifySpecimenFromRequisitionController(reqid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequisitionApi
     */
    RequisitionApi.prototype.youScriptResultsFromRequisitionController = function (id, options) {
        var _this = this;
        return (0, exports.RequisitionApiFp)(this.configuration).youScriptResultsFromRequisitionController(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RequisitionApi;
}(base_1.BaseAPI));
exports.RequisitionApi = RequisitionApi;
